export var SCALES_CASES='SCALES_CASES';// a cell that uses both constructed scales and cases
export var CASES='CASES';// a cell that uses only cases
export var SCALES='SCALES';// a cell that uses constructed scales
export var DEFAULT='DEFAULT';// a unformatted cell
export var PARENT='PARENT';// a cell with children


//////////////////
// WEBPACK FOOTER
// ./src/utilities/cellTypes.js
// module id = 836
// module chunks = 29